/**
 * User admin API calls.
 */

import client from './client';

export async function fetchUsers(params = {}) {
  const { data } = await client.get('/auth/users/', { params });
  return data;
}

export async function fetchUser(id) {
  const { data } = await client.get(`/auth/users/${id}/`);
  return data.data || data;
}

export async function updateUser(id, payload) {
  const { data } = await client.patch(`/auth/users/${id}/`, payload);
  return data.data || data;
}

export async function registerUser(payload) {
  const { data } = await client.post('/auth/register/', payload);
  return data.data || data;
}

export async function setUserPassword(id, newPassword) {
  const { data } = await client.post(`/auth/users/${id}/set-password/`, {
    new_password: newPassword,
  });
  return data.data || data;
}
